import { clsx } from 'clsx';
import { addDotAtTheEndOfString } from "../../helpers/addDotAtTheEndOfString";
import { TOAST_COLORS } from "../constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ToastInformation = function ToastInformation(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'informative' : _ref$type,
    textLink = _ref.textLink;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex-grow",
    children: [/*#__PURE__*/_jsx("h2", {
      className: clsx('tw-font-subtitle5  dark:tw-text-neutral-light-100 tw-line-clamp-3 md:tw-line-clamp-2', TOAST_COLORS[type].text.light),
      children: title
    }), subtitle && /*#__PURE__*/_jsxs("p", {
      className: "tw-mt-0.4 tw-text-neutral-light-700 dark:tw-text-neutral-light-100 tw-font-body5 tw-line-clamp-3 md:tw-line-clamp-2",
      children: [addDotAtTheEndOfString(subtitle), textLink && /*#__PURE__*/_jsx("span", {
        className: clsx('tw-ml-0.4 dark:tw-text-inherit', TOAST_COLORS[type].text.light),
        children: /*#__PURE__*/_jsx("a", {
          className: "tw-font-caption tw-underline",
          href: textLink.href,
          target: "_blank",
          rel: "noreferrer",
          children: textLink.text
        })
      })]
    })]
  });
};